<script setup lang="ts">
import { IonNote } from "@ionic/vue";

const version = import.meta.env.PACKAGE_VERSION;
const gitBranch = import.meta.env.GIT_BRANCH;
</script>

<template>
  <div class="app-version">
    <IonNote>
      <small>
        Version {{ version }}
        <template v-if="gitBranch !== 'main'">({{ gitBranch }})</template>
      </small>
    </IonNote>
  </div>
</template>
